import styles from './loading.module.scss';

const Loading = () => {
    return (
        <div className={styles.container}>
            <div className={styles.loaderText}></div>
        </div>
    );
};

export default Loading;
